import { Location } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { HeaderData } from '../../pim-graphql/views/shared-view.model';

@Component({
  selector: 'app-shared-header',
  templateUrl: './shared-header.component.html',
  styleUrls: ['./shared-header.component.scss'],
  standalone: false,
})
export class SharedHeaderComponent {
  private location = inject(Location);

  @Input() headerData?: HeaderData;
  @Input() loading = true;
  @Input() startPage = false;

  backNav() {
    this.location.back();
  }
}
